import React from "react";
import HeaderTwo from "../components/HeaderTwo";
import BannerTwo from "../components/BannerThree";
import PromotionalTwo from "../components/PromotionalThree";
import PromotionalTwos from "../components/PromotionalFour";
import DealsOne from "../components/DealsOne";
import DiscountOne from "../components/DiscountOne";
import RecentlyViewedOne from "../components/RecentlyViewedOne";
import ShippingTwo from "../components/ShippingTwo";
import FooterTwo from "../components/FooterTwo";
import BottomFooter from "../components/BottomFooter";
import WhyChooseUs from "../components/WhyChooseUs";
import FeaturedProducts from "../components/FeaturedProducts";
import PremuimInk from "../components/PremuimInk";
import Choose from "../components/Choose";
import Faq from "../components/Faqs";
import Testimonial from "../components/Testimonial";
import ColorInit from "../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import { Helmet } from "react-helmet-async";

const HomePageTwo = () => {
  return (
    <>
      <Helmet>
        <title>Book An Appointment (Awaneez)</title>
      </Helmet>
      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#2694e9" />

      {/* BannerTwo */}
      <BannerTwo />

      {/* PromotionalTwo */}
      <PromotionalTwo />

      {/* Faq */}
      <Faq />

      {/* PromotionalTwo */}
      <PromotionalTwos />

      {/* Testimonial */}
      <Testimonial />

      {/* FooterTwo */}
      <FooterTwo />
    </>
  );
};

export default HomePageTwo;
